import axios from 'axios'

export default {
  search (query) {
    return axios.get(`/employees?query=${query}&skip_me=true`)
      .catch((err) => { window.alert(err) })
  }
}
